import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import DateDisplay from 'src/components/DateDisplay'
import { CandidateContractualDocumentById } from 'src/queries'

interface ListProps {
  candidate: CandidateContractualDocumentById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { candidate } = props
  const section1: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Staffing Agency',
      value: <DateDisplay id='StaffingAgencyNda' date={candidate?.nda_signed?.staffing_agency} />
    },
    {
      title: 'Candidate',
      value: <DateDisplay id='CandidateNda' date={candidate?.nda_signed?.candidate} />
    }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: candidate === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section1.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
